/**
 * Route shell only. The screen is @alight/enrolment-ui, shared with apps/site
 * — one implementation, two databases (docs/HTBH-MIGRATION.md §8a).
 */
import { createFileRoute } from "@tanstack/react-router";
import { PayPage } from "@alight/enrolment-ui";

export const Route = createFileRoute("/pay/$ref")({
  /* Mirrors apps/site — Stripe's return hop. PayPage reads these via
   * useSearch({ strict: false }), so both apps must declare them. */
  validateSearch: (s: Record<string, unknown>): { paid?: boolean; cancelled?: boolean } => ({
    paid: s.paid === "1" || s.paid === true ? true : undefined,
    cancelled: s.cancelled === "1" || s.cancelled === true ? true : undefined,
  }),
  component: PayPage,
});
